export default "__VITE_ASSET__BfLRuELa__"